module.exports = __webpack_public_path__ + "static/media/purolatoricon.3ec6c4f6.svg";